<template>
  <div class="box7">
    <div class="content-box">
      <div class="title-btn">商科教授</div>
      <div class="title-text">具体授课教授以院校安排为准</div>
      <div class="list-box">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="item-icon"></div>
          <div class="item-top">
            <img class="left-pic" :src="item.pic" />
            <div class="right-text">
              <div class="job">{{ item.job }}</div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
          <div class="education">{{ item.education1 }}</div>
          <div v-if="item.education2" class="education">{{ item.education2 }}</div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      list: [
        {
          pic: require('../../../assets/coursePage/illinois/box7/pic1.png'),
          job: '商学院院长  教授',
          name: 'Liad Wagman',
          education1: 'MBA项目微观经济学与博弈论授课教师',
          education2: '杜克大学博士、硕士，斯坦福大学硕士',
          description: '曾就职于美国联邦贸易委员会，领导研究谷歌、亚马逊、苹果、微软等并购垄断，研究直接影响美国国会立法。曾任西北大学高管教育管理客座副教授、杜克大学、斯坦福大学研究员。'
        }, 
        {
          pic: require('../../../assets/coursePage/illinois/box7/pic2.png'),
          job: '商业项目主任  副院长',
          name: 'M.Krishna Erramilli',
          education1: 'MBA项目商业战略和创新授课教师',
          education2: '拥有阿肯色大学博士学位',
          description: '曾任新加坡南洋理工大学商学院副院长、教授美国西南国际商务学院主席，主导开发了伯克利+南洋理工高级管理课程。30年的专业经验横跨北美、亚非学界和业界，参与了三星、毕马威、杜邦等跨国高冠教育项目。'
        }, 
        {
          pic: require('../../../assets/coursePage/illinois/box7/pic3.png'),
          job: '教授',
          name: 'Marian M.Cook',
          education1: 'MBA项目商业战略顶点课程授课教师',
          education2: '北伊利诺伊大学MBA学位，哈佛大学高等教育、美国西北大学授课认证',
          description: '任麻省理工学院区块链课程首席学习导师、多伦多大学数字化转型、耶鲁大学高管教育教授，在美国伊利诺伊州创新技术部任首席战略官，在州政府数字化转型拥有影响力。'
        }, 
        {
          pic: require('../../../assets/coursePage/illinois/box7/pic4.png'),
          job: '教授',
          name: 'Khairy A.Tourk',
          education1: '拥有加州大学伯克利分校经济学博士学位、范德堡大学硕士学位',
          description: '曾担任国际货币基金组织(IMF)、世界银行国际开发署和美国商务部顾问，中国人民大学东京大学、名古屋大学客座教授。现任芝加哥大学中国研究小组成员。新华社、人民日报、中央电视台多次采访，并在《新闻联播》播出。'
        }, 
      ]
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box7 {
  padding: 40px 0 80px;
  width: 100%;
  background: #F4F4FB;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
  .content-box {
    overflow: hidden;
    margin: 0 auto;
    width: 686px;
    background: #FFFFFF;
    border-radius: 24px;
    .title-btn {
      margin: 48px auto 0;
      width: 320px;
      height: 72px;
      background: #D83F3F;
      border-radius: 50px;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 72px;
      text-align: center;
    }
    .title-text {
      margin-top: 32px;
      font-weight: 400;
      font-size: 28px;
      color: #272020;
      line-height: 44px;
      text-align: center;
    }
    .list-box {
      margin: 32px auto 0;
      width: 638px;
      border-radius: 32px;
      .list-item {
        margin-bottom: 24px;
        position: relative;
        padding: 40px;
        border-radius: 26px;
        background: #FAFAFD;
        .item-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 72px;
          height: 72px;
          background: url('../../../assets/coursePage/illinois/box7/bg-icon.png') no-repeat;
          background-size: cover;
        }
        .item-top {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 32px;
        }
        .left-pic {
          width: 216px;
          height: 216px;
          margin-right: 40px;
        } 
        .right-text {
          .name {
            font-weight: 600;
            font-size: 40px;
            color: #272020;
            line-height: 52px;
            text-align: left;
            white-space: nowrap;
          }
          .job {
            margin-top: 96px;
            font-weight: 400;
            font-size: 28px;
            color: #D83F3F;
            line-height: 44px;
            text-align: left;
          }
        }
        .education {
          position: relative;
          margin-left: 20px;
          font-weight: 600;
          font-size: 28px;
          color: #272020;
          line-height: 44px;
          text-align: left;
          &::before {
            position: absolute;
            content: '';
            top: 16px;
            bottom: 0;
            left: -20px;
            content: '';
            width: 8px;
            height: 8px;
            background: #EB2637;
            border-radius: 50%;
          }
        }
        .description {
          margin-top: 24px;
          font-weight: 400;
          font-size: 26px;
          color: #847D7D;
          line-height: 40px;
          text-align: left;
        }
      }
      .list-item:nth-child(2) {
        .right-text {
          .job {
            margin-top: 44px;
          }
          .name {
            white-space: normal;
          }
        }
      }
    }
  }
}
</style>
